export const cartConfig = {
  defaultCurrency: "PLN",
  itemsLimit: 15,
};
